export default __webpack_public_path__ + "static/media/SOCIALSECURITYCERTIFICATE.944c75e1.png";